import { render, staticRenderFns } from "./Verifiction.vue?vue&type=template&id=4b71fdf4&scoped=true"
import script from "./Verifiction.vue?vue&type=script&lang=js"
export * from "./Verifiction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b71fdf4",
  null
  
)

export default component.exports